import { Component, ViewChild } from '@angular/core';

import { AlertController, App, ItemSliding, List, ModalController, NavController } from 'ionic-angular';


import { JobInfo } from '../job-info/job-info';

import { UserData } from '../../providers/user-data';

import { Http } from '@angular/http';

import 'rxjs/add/operator/map';


@Component({
  templateUrl: 'build/pages/myjobs/myjobs.html',
})
export class MyjobsPage {

   jobs: Array<any>;

 username: string;


  constructor(
    public alertCtrl: AlertController,
    public app: App,
    public modalCtrl: ModalController,
    public navCtrl: NavController,
    public user: UserData,
    private http: Http
  ) {

  }

  ionViewDidEnter() {
    this.app.setTitle('Job Info');
  }


   ngAfterViewInit() {
    this.loadjobs();
  }


 getUsername() {
    this.user.getUsername().then((username) => {
      this.username = username;
    
    });
  }


  loadjobs() {

  this.user.getUsername().then((username) => {
    this.username = username;
 var url = 'http://letpco.co.uk/api/v1/myjobs?authkey='+this.username;

          this.http.get(url).subscribe(res => {

 this.jobs = res.json().data;
        
     
      });

 return 'hi';

  });
    }


    itemTapped(event, movie) {
        this.navCtrl.push(JobInfo, movie.jobid);
    }




}
